<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card title="Value Added Moments (VAM)" titleIcon="FlagIcon" ref="filterCard">
        <vx-card class="p-4" noShadow cardBorder>
          <div class="vx-row">
            <div class="w-full vx-col md:w-1/3 sm:w-1/2">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="w-full mb-4 md:mb-0" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']"
                placeholder="Choose Date" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']"
                placeholder="Choose Date" />
            </div>
          </div>
          <div class="mt-5 vx-row">
            <div class="w-full ml-auto vx-col">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <template slot="actions">
          <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus"
            class="mr-4" color="primary" type="filled">create</vs-button>
        </template>
        <div id="incoterms-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th sort-key="code" width="10%">CODE</vs-th>
                <vs-th WIDTH="10%">CREATED DATE/TIME</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th width="12%">TYPE(S)</vs-th>
                <!-- <vs-th width="10%">REASON CODE</vs-th> -->
                <vs-th width="10%">DATE</vs-th>
                <vs-th width="10%">LINKED SO</vs-th>
                <vs-th width="20%">DESCRIPTION</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(data[indextr].id)" class="cursor-pointer" :key="indextr"
                  v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].code">
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].created_by_staff }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].type.map(type => type).join(", ") }}
                  </vs-td>

                  <!-- <vs-td>
                    {{ data[indextr].reason || '-' }}
                  </vs-td> -->

                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date || '-' }}
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].product_orders.length > 0">
                      <span v-for="(order, index) in data[indextr].product_orders" :key="index">
                        <span @click.stop="onClickOpenSo(order.id)" class="text-primary cursor-pointer">{{ order.product_order_code }}</span>
                      </span>
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].description || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small" color="warning"
                          type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Delete" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <create-customer-crm-snapshot-pop-up ref="createCustomerCrmSnapshotPopUp" :customer_id="customerId" />
  </div>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import CreateCustomerCrmSnapshotPopUp from '@/components/popups/crm/customer/snapshots/CreateCustomerCrmSnapshotPopUp.vue'

import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
const CrmRepository = RepositoryFactory.get('crm');

export default {
  name: "CustomerCrmSnapshotList",
  data() {
    return {
      incoterms: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      customerId: null,
    }
  },
  props: {
    contact_type: {
      type: String,
      default: 'email'
    }
  },
  components: {
    CreateCustomerCrmSnapshotPopUp,
    'v-select': vSelect,
    flatPickr
  },
  methods: {
    async refreshData() {
      await this.fetchSnapshotList()
      await this.$emit('refreshSummary')
    },
    async fetchSnapshotList() {
      await this.$vs.loading({
        container: '#incoterms-table',
        scale: 0.45
      })
      try {
        const { data } = await CrmRepository.getListOfCustomerSnapshot(this.customerId, this.page, `${this.filterQuery}&filter[customer-ids]=${this.customerId}`, this.perPage)
        this.incoterms = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close('#incoterms-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.createCustomerCrmSnapshotPopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.createCustomerCrmSnapshotPopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        acceptText: 'Confirm',
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await CrmRepository.deleteCustomerSnapshot(params[0])
        await this.fetchSnapshotList()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    filterQueryUpdate() {
      this.fetchSnapshotList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSnapshotList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSnapshotList()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    onClickOpenSo(id) {
      const route = this.$router.resolve({ path: `/pages/product-orders/${id}` });
      window.open(route.href, '_blank');
    }
  },
  async mounted() {
    this.customerId = this.$route.params.id
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchSnapshotList()
    },
    perPage() {
      this.fetchSnapshotList()
    }
  }
}
</script>
  
<style scoped></style>
  